

























































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import authService from '@/users/services/auth-service'
import AccountModule from '@/users/store/account-module'
import AuthModule from '@/users/store/auth-module'
import User from '@/users/entities/user'

@Component
export default class UserWidget extends Vue {
  private menu: boolean = false

  get user() {
    const accountModule = getModule(AccountModule, this.$store)
    const data = accountModule.userData
    return data || new User()
  }

  get firstName() {
    return this.user.firstName || ' '
  }

  get lastName() {
    return this.user.lastName || ' '
  }

  get email() {
    return this.user.email || ' '
  }

  get roles() {
    const authModule = getModule(AuthModule, this.$store)
    return authModule.roles
  }

  get initials() {
    const firstNameInitial = this.firstName.charAt(0).toUpperCase()
    const lastNameInitial = this.lastName.charAt(0).toUpperCase()
    return firstNameInitial + lastNameInitial
  }

  private goToSettings() {
    this.$router.push({
      name: 'settings',
      params: { lang: this.$i18n.locale },
    })
    this.menu = false
  }

  private async logout() {
    this.menu = false
    await authService.logoutAsync()
  }
}
